import React, {Component} from "react";
import {startSession} from "./history/Session";
import {Route, Switch} from "react-router-dom";
import "./styles/main.css";
import NoConnection from "./components/shared/NoConnection";
import {connect} from "react-redux";
import Toast from "./components/shared/Toast";
import HomeApp from "./components/home/HomeApp";
import Login from "./components/register/Login";
import Home from "./components/landing/Home";
import ForgotPassword from "./components/register/ForgotPassword";
import Register from "./components/register/Register";
import SendCode from "./components/register/SendCode";
import NewTask from "./components/task/NewTask";
import CategoryList from "./components/tutor/CategoryList";
import Profile from "./components/register/Profile";
import Chat from "./components/home/Chat";
import SendAnswer from "./components/task/SendAnswer";
import Score from "./components/task/Score";
import FavoriteList from "./components/tutor/FavoriteList";
import Transactions from "./components/tutor/Transactions";
import Tasks from "./components/task/Tasks";
import Privacy from "./components/landing/Privacy";
import NotFound from "./components/landing/NotFound";
import {appVersion} from "./utils/API";
import Objects from "./redux/Objects";
import {set} from "./redux/Action";
import Receipt from "./components/home/Receipt";
import DeleteAccount from "./components/register/DeleteAccount";


class App extends Component {
    constructor(props) {
        super(props)
        appVersion((res) => {
            props.dispatch(set(Objects.talkAppId, res.TALK_JS_APP_ID))
        })

        startSession()

        // if (!isInStandaloneMode() && window.location.pathname.startsWith("/hom") && (isIos() || isAndroid())) {
        //     history.push("/add-to-home-screen")
        // }
        // if (isInStandaloneMode() && (isIos() || isAndroid())) {
        //     history.push("/hom")
        // }
    }

    render() {
        return (
            <div className="App">
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/privacy-and-policy" component={Privacy}/>
                    <Route exact path="/pay/receipt" component={Receipt}/>
                    <Route exact path="/hom" component={HomeApp}/>
                    <Route exact path="/hom/login" component={Login}/>
                    <Route exact path="/hom/forgot-password" component={ForgotPassword}/>
                    <Route exact path="/hom/register" component={Register}/>
                    <Route exact path="/hom/send-code" component={SendCode}/>
                    <Route exact path="/hom/new-task" component={NewTask}/>
                    <Route exact path="/hom/new-task/:tutorId" component={NewTask}/>
                    <Route exact path="/hom/category" component={CategoryList}/>
                    <Route exact path="/hom/profile" component={Profile}/>
                    <Route exact path="/hom/chat/:me/:other" component={Chat}/>
                    <Route exact path="/hom/send-answer" component={SendAnswer}/>
                    <Route exact path="/hom/score" component={Score}/>
                    <Route exact path="/hom/favorite" component={FavoriteList}/>
                    <Route exact path="/hom/transaction" component={Transactions}/>
                    <Route exact path="/hom/delete-account" component={DeleteAccount}/>
                    <Route exact path="/hom/task" component={Tasks}/>
                    <Route component={NotFound}/>
                </Switch>
                <NoConnection/>
                <Toast/>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
